import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  LoadRosterStructureParams,
  RosterStructureRepository,
} from '@softapps/pms/roster-core';
import { SOFTLINE_API_DELIVERY_NOTE_ROSTER_STRUCTURE } from '../delivery-note-roster.api';
import { RosterDeliveryStructure } from '../types/roster-delivery-structure';

@Injectable()
export class DeliveryNoteRosterStructureRepository extends RosterStructureRepository<
  RosterDeliveryStructure[]
> {
  readonly #dataAccess = inject(ApiDataAccess);

  async load(_params: LoadRosterStructureParams): Promise<RosterDeliveryStructure[]> {
    return this.#dataAccess.get({ path: SOFTLINE_API_DELIVERY_NOTE_ROSTER_STRUCTURE });
  }
}
